/** Brand logo with full wordmark or compact icon. */
export const Logo = ({ size = 48, withWordmark = true, className = "" }) => {
  const source = withWordmark
    ? "/Design_3-transparent-full.png"
    : "/Design_3-transparent-icon.png";
  const width = withWordmark ? Math.round(size * 1.83) : Math.round(size * 0.88);

  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={source}
        alt="Guided Sentry"
        width={width}
        height={size}
        className="object-contain"
        draggable={false}
      />
    </div>
  );
};

export default Logo;
